import { valueStrings } from "constants/constantStrings";
import { MEDIUM_GREY, ORANGE_COLOR, PRIMARY_BLACK, PRIMARY_COLOR, PRIMARY_RED_COLOR, PRIMARY_WHITE } from "constants/globalConstants";

export const gaugeLayout = {
  width: 300,
  height: 180,
  margin: { t: 30, r: 50, l: 50, b: 25 },
  font: { color: MEDIUM_GREY },
  paper_bgcolor: "transparent"
};

export const getGaugeData = (Value, unit, L, LL, H, HH, WidgetSubtype) => {
  const segmentColors = segmentColorsOptionsCode[WidgetSubtype];

  const data = [
    {
      type: "indicator",
      mode: "gauge+number",
      value: Value,
      number: {
        // This can't be move to CSS Files, can override style inline only
        suffix: `<br><span style="font: 12px Noto Sans; color: #969696 !important;">(${unit})<span>`,
        font: { family: "Diodrum-Semibold", color: getValueColor(Value, L, H, WidgetSubtype), size: "16" },
        valueformat: ".2f"
      },
      gauge: {
        axis: {
          range: [LL.Value, HH.Value],
          tickvals: [LL.Value, L.Value, H.Value, HH.Value],
          ticklen: 0,
          tickangle: "0"
        },

        bgcolor: PRIMARY_WHITE,
        borderwidth: 0.5,
        bordercolor: MEDIUM_GREY,
        bar: { thickness: 0 },
        steps: [
          { range: [LL.Value, L.Value], color: segmentColors[0] },
          { range: [L.Value, H.Value], color: segmentColors[1] },
          { range: [H.Value, HH.Value], color: segmentColors[2] }
        ],
        threshold: {
          line: { color: PRIMARY_BLACK, width: 5 },
          thickness: 1,
          value: Value
        }
      }
    }
  ];

  return data;
};

const getValueColor = (Value, L, H, WidgetSubtype) => {
  let colorIDX = 0;
  const colors = segmentColorsOptionsCode[WidgetSubtype];
  const currentVal = Value;
  if (currentVal <= L.Value) {
    colorIDX = 0;
  } else if (currentVal >= H.Value) {
    colorIDX = 2;
  } else {
    colorIDX = 1;
  }
  return colors[colorIDX];
};

export const segmentColorsOptionsCode = {
  MiddleGauge: [PRIMARY_RED_COLOR, PRIMARY_COLOR, PRIMARY_RED_COLOR],
  RightGauge: [PRIMARY_RED_COLOR, ORANGE_COLOR, PRIMARY_COLOR],
  LeftGauge: [PRIMARY_COLOR, ORANGE_COLOR, PRIMARY_RED_COLOR]
};

export const getErrorMsg = isToHide => {
  if (isToHide) {
    return valueStrings.gaugeValueErrorForOffline;
  }
  return valueStrings.gaugeValueError;
};
